import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=f2fdb76e&scoped=true&"
import script from "./SignDialog.vue?vue&type=script&lang=js&"
export * from "./SignDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignDialog.vue?vue&type=style&index=0&id=f2fdb76e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fdb76e",
  null
  
)

export default component.exports